import { Box, Flex, HStack, Table, TableContainer, Tbody, Text, Th, Thead, Tr, useDisclosure } from '@chakra-ui/react'
import moment from 'moment'
import React, { useEffect } from 'react'
import { useState } from 'react'
import { AiOutlinePlus } from 'react-icons/ai'
import { FaSearch } from 'react-icons/fa'
import CreateShelfModal from '../Components/CreateShelfModal'
import Input from '../Components/Input'
import Pagination from '../Components/Pagination'
import PickUpModal from '../Components/PickUpModal'
import Preloader from '../Components/Preloader'
import PrintPickUpGroup from '../Components/PrintPickupGroup'
import SearchComponent from '../Components/SearchComponent'
import TableRow from '../Components/TableRow'
import MainLayout from '../Layouts/Index'
import { ConfirmPickUp, GetAllProductShelf, ReadAllGroupRequest, ReadAllRequest, ReadRequestHistory, SingleTicketNumber } from '../Utils/ApiCalls'
import Seo from '../Utils/Seo'
import PrintPickUp from './PrintPickUp'
import { configuration } from '../Utils/config'
import HistoryRequest from '../Components/HistoryRequest'
import { useNavigate } from 'react-router-dom'

export default function PickUpGroup() {
    const { isOpen, onOpen, onClose } = useDisclosure();


    const [ModelState, setModelState] = useState(false);
    const [PrintMode, setPrintMode] = useState(false);

    const [SearchText, setSearchText] = useState("");
    const [SingleData, setSingleData] = useState(false);
    const [SingleDataArr, setSingleDataArr] = useState(false);
    const [MainData, setMainData] = useState(false);

    const [Data, setData] = useState([]);
    const [HistoryData, setHistoryData] = useState([]);
    const [PreLoader, setPreLoader] = useState(true);


    //get current post

    const [CurrentPage, setCurrentPage] = useState(1);
    const [PostperPage, setPostperPage] = useState(configuration.sizeperpage);
    const indexOfLastSra = CurrentPage * PostperPage;
    const indexOfFirstSra = indexOfLastSra - PostperPage;
    const currentData = Data?.slice(indexOfFirstSra, indexOfLastSra);
    //change page 
    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber)
    }
    const [Result, setResult] = useState([]);





    const GetAllRequest = async () => {
        let result = await ReadAllGroupRequest()

        console.log("result group request", result);

        if (result.status == true) {
            setData(result.queryresult)

            setPreLoader(false)
        }
    }
    console.log("result Datta", Data);





    // const filterData = (e) => {

    //     setSearchText(e.target.value)

    //     let result = Data.filter((item) => item.productname.includes(SearchText) || item.productshelfid.includes(SearchText) || item.category?.name.includes(SearchText))

    //     setResult(result)

    // }

    const FetchSingle = async (ticketID)=>{
        try{
         
            let result = await SingleTicketNumber(ticketID)

            console.log("FetchSingle", result)
            if(result.status === true){

            
                setSingleDataArr(result.queryresult.allrequest)

                
           onOpen()
            }

        }catch(e){

            console.log(e)
        }
    }

 

    const Proceed = (id) => {

        FetchSingle(id)
       

    }


    const OpenHistory = async (id) => {


        let result = await ReadRequestHistory(id)

        console.log("result history", result);

        if (result.status == true) {
            setHistoryData(result.queryresult.allrequest)
            setModelState(true)


        }
    }

    const Print = (id) => {


        setPrintMode(true)
        setSingleData(id)

    }
    const nav = useNavigate()

    const back = () => {

        setPrintMode(false)
    }





    useEffect(() => {
        GetAllRequest()
    }, [isOpen]);
    return (
        <>
            {
                PreLoader && (

                    <Preloader />
                )
            }
            {
                PrintMode ? (
                    <PrintPickUpGroup SingleData={SingleData} mainData={MainData} onClick={back} />

                ) : (
                    <MainLayout>
                        <Seo title="Pick up" description='EKO IMS - Pick up' />
                        <Flex justifyContent={"flex-end"} flexWrap="wrap" fontWeight={"500"} >


                            <Text textTransform="capitalize">Total Product Request - {Data.length}</Text>

                        </Flex>


                        <SearchComponent SearchText={SearchText} setSearchText={(e) => setSearchText(e.target.value)} Keywords={"TicketNo, StaffId, StaffMail"} />
                        <Box height="70vh" minH={"70vh"} overflow="auto" _hover={{ overflow: "auto" }} bg="blue.blue300" mt="32px" rounded={"8px"}>


                            <TableContainer mt="32px" overflowX="auto" color="#fff">
                                <Table variant='simple' size='sm'>
                                    <Thead>
                                        <Tr>
                                            <Th color="#fff">S/N</Th>
                                            <Th color="#fff">TicketNo</Th>
                                            <Th color="#fff">Store</Th>
                                            <Th color="#fff">Staff ID</Th>
                                            <Th color="#fff">staff Email</Th>
                                            <Th color="#fff">Department</Th>
                                            <Th color="#fff">Request Date</Th>
                                            <Th color="#fff">Created Date</Th>
                                            <Th color="#fff">First Approval</Th>
                                            <Th color="#fff">Print</Th>
                                            <Th color="#fff">History</Th>
                                            <Th color="#fff">Action</Th>


                                        </Tr>
                                    </Thead>
                                    <Tbody>
                                        {
                                            SearchText === "" ? (
                                                currentData?.map((item, i) => (
                                                    <TableRow
                                                        type={"pickUpGroup"}
                                                        key={i}
                                                        sn={i + 1}
                                                        ticketNo={item.ticket}
                                                        store={item.store}
                                                        staffId={item.staffid}
                                                        email={item.staffemail}
                                                        dept={item.department}
                                                        dateReceived={moment(item.requestdate).format('DD/MM/YYYY')}
                                                        timestamp={moment(item.createdAt).format('DD/MM/YYYY, h:mm:ss a')}
                                                        approval={item.zm ? item.zm : item.dom ? item.dom : item.hodbd ? item.hodbd : item.hodpt ? item.hodpt : item.dm ? item.dm : item.hdo ? item.hdo : ""}
                                                        onClick={() => Proceed(item.ticket)}
                                                        history={() => OpenHistory(item.staffid)}
                                                        print={() => Print(item)}

                                                    />
                                                ))
                                            ) : (
                                                SearchText !== "" && Data.filter(item => item.ticket?.includes(SearchText) || item.staffid?.includes(SearchText) || item.staffemail?.includes(SearchText)).length > 0 ?
                                                    (

                                                        Data.filter(item => item.ticket?.includes(SearchText) || item.staffid?.includes(SearchText) || item.staffemail?.includes(SearchText)).

                                                            map((item, i) => (
                                                                <TableRow
                                                                    type={"pickUpGroup"}
                                                                    key={i}
                                                                    sn={i + 1}
                                                                    ticketNo={item.ticket}
                                                                    staffId={item.staffid}
                                                                    email={item.staffemail}
                                                                    dept={item.department}
                                                                    dateReceived={moment(item.requestdate).format('DD/MM/YYYY')}
                                                                    onClick={() => Proceed(item.ticket)}
                                                                    history={() => OpenHistory(item.staffid)}
                                                                    print={() => Print(item)}

                                                                />
                                                            ))
                                                    ) : (
                                                        <Text textAlign={"right"} mt="32px" color="#ddd">*--No result found--*</Text>

                                                    )
                                            )

                                        }
                                    </Tbody>

                                </Table>
                            </TableContainer>

                            <Pagination postPerpage={PostperPage} currentPage={CurrentPage} totalPosts={Data?.length} paginate={paginate} />


                        </Box>
                        <PickUpModal isOpen={isOpen} onCloseX={onClose} singleData={SingleDataArr} setPreLoader={setPreLoader} />
                        <HistoryRequest isOpen={ModelState} onClose={() => setModelState(false)} singleData={HistoryData} />
                    </MainLayout>
                )
            }
        </>
    )
}
